/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoEfsModelsExceptionListItem,
    EfsMelcoEfsModelsExceptionListItemFromJSON,
    EfsMelcoEfsModelsExceptionListItemFromJSONTyped,
    EfsMelcoEfsModelsExceptionListItemToJSON,
    EfsMelcoModelsCustomWarning,
    EfsMelcoModelsCustomWarningFromJSON,
    EfsMelcoModelsCustomWarningFromJSONTyped,
    EfsMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem
 */
export interface EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem {
    /**
     * 
     * @type {Array<EfsMelcoEfsModelsExceptionListItem>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem
     */
    list: Array<EfsMelcoEfsModelsExceptionListItem>;
    /**
     * 
     * @type {Array<EfsMelcoModelsCustomWarning>}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem
     */
    warning_list?: Array<EfsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem
     */
    total: number;
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItemFromJSON(json: any): EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem {
    return EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItemFromJSONTyped(json, false);
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(EfsMelcoEfsModelsExceptionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(EfsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItemToJSON(value?: EfsMelcoModelsGenericList1MelcoEfsModelsExceptionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(EfsMelcoEfsModelsExceptionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(EfsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


